import { Component, OnInit, ViewChild, TemplateRef , ElementRef } from '@angular/core';
import { SelfService } from '../self-services.service.ts';
import { BpgChapterHomePageService } from '../../bpg-chapter-home-page/bpg-chapter-home-page.service';
import { ConstantValues } from './../../bpg-common/models/bpg-constants';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { BpgEventsService } from '../../bpg-events/bpg-events.service';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { BpgCommonService } from 'src/app/bpg-common/services/bpg-common.service.js';

@Component({
  selector: 'app-chapter',
  templateUrl: './chapter.component.html',
  styleUrls: ['./chapter.component.css']
})
export class ChapterComponent implements OnInit {
  @ViewChild("myckeditor", { static: false }) ckeditor: any;
  @ViewChild('myInputBannerImage', { static: false }) myInputBannerImageVariable: ElementRef;
  @ViewChild('myInputChairImage', { static: false }) myInputChairImageVariable: ElementRef;
  @ViewChild('myInputViseChairImage', { static: false }) myInputViseChairImageVariable: ElementRef;
  @ViewChild('myInputFinanceChairImage', { static: false }) myInputFinanceChairImageVariable: ElementRef;
  @ViewChild('myInputCommunicationChairImage', { static: false }) myInputCommunicationChairImageVariable: ElementRef;
  @ViewChild('myInputExecutiveSponserImage', { static: false }) myInputExecutiveSponserImageVariable: ElementRef;
  @ViewChild('callAPIDialog', { static: false }) callAPIDialog: TemplateRef<any>;
  @ViewChild('myInput', { static: false })
  myInputVariable: ElementRef;
  landingDto: any;
  bpgName: string = null;
  bpgId = "";
  chapterData = [];
  editandSavebtn = false;
  savebtn = false;
  areaofimpactId: string;
  alertSuccess: boolean;
  alertFailure: boolean;
  alertUpdate: boolean;
  siteList: any[];
  bpgList: any[];
  loginUserId: any;
  bpgChapterDetails: any;
  duplicatecheck: any = [];
  visionStmt: string;
  missionStmt: string;
  visionValues: string;

  imagePath: string;

  chapterId = '0';
  chaptersDTO = [];
  siteId = "";
  siteName: string = null;

  startDate = "";
  endDate = "";
  chapterBanner: string = null;
  chapterBannerImage: string = null;
  executiveSponser: string = null;
  executiveSponsorImage: string = null;

  chairImage = "";
  viceChairImage = "";
  financeChairImage = "";
  communicationChairImage = "";

  chapterVision: string = null;
  chapterMission: string = null;
  chapterEmail: string = null;
  setStatus = true;
  bpgDate: any = null;
  sponserName: string = null;
  sponsorEmailId: string = null;
  chaptersLeadership: any;
  curDate: any;

  selectMemberChair: any;
  uploadPhotoChair: string = null;
  uploadPhotoChairImage: string = null;
  descriptionChair = "";

  chairEmailId = "";
  viceChairEmailId = "";
  financeChairEmailId = "";
  commChairEmailId = "";

  selectMemberViceChair: any;
  uploadPhotoViceChair: string = null;
  uploadPhotoViceChairImage: string = null;
  descriptionViceChair = "";


  selectMemberFinanceChair: any;
  uploadPhotoFinanceChair: string = null;
  uploadPhotoFinanceChairImage: string = null;
  descriptionFinanceChair = "";

  selectMemberCommunicationChair: any;
  uploadPhotoCommunicationChair: string = null;
  uploadPhotoCommunicationChairImage: string = null;
  descriptionCommunicationChair = "";

  userId1: string = null;
  userId2: string = null;
  userId3: string = null;
  userId4: string = null;
  leadershipChairList = [];
  leadershipViceChairList = [];
  leadershipCommunicationChairList = [];
  leadershipFinanceChairList = [];
  leadershipChairDuplicateCheck: boolean;
  duplicateMessage = "";

  uploadFileName = "";
  imagecheck: any;
  siteBannerImage = "";
  uploadFileExtension: boolean;
  uploadFileBannerExtension: boolean;
  uploadLeadershipChairFileExtension: boolean;
  uploadLeadershipViceChairFileExtension: boolean;
  uploadLeadershipFinanceChairFileExtension: boolean;
  uploadLeadershipCommunicationChairFileExtension: boolean;
  uploadExecutiveSponserFileExtension: boolean;
  width: number;
  height: number;

  isExistChapter: boolean;
  visionBlankCheck: boolean;

  userSiteId = "";

  numberOfElements: number;
  currentPage = 0;
  limit: number = ConstantValues.pageLimit;
  totalPages = 0;
  currentShowingElements: number = ConstantValues.pageLimit;
  searchKey: any;
  tableresp: boolean;
  errorMessage = "";
  errorMessageActive: boolean;
  tableShow: boolean;
  noDataFound: boolean;

  flag1: boolean;
  flag2: boolean;
  flag3: boolean;
  flag4: boolean;
  flag5: boolean;
  flag6: boolean;

  invalidChairEmail: boolean;
  invalidViceChairEmail: boolean;
  invalidFinanceChairEmail: boolean;
  invalidCommChairEmail: boolean;
  invalidExecutiveSponsorEmail: boolean;
  isChairEmailBlank: boolean;
  isViceEmailBlank: boolean;
  isFinanceEmailBlank: boolean;
  isCommEmailBlank: boolean;
  isSponsorEmailBlank: boolean;

  banner;
  chair;
  viceChair;
  financeChair;
  communicationChair;
  sponser;
  tempChairError: boolean;
  tempViceChairError: boolean;
  tempFinanceChairError: boolean;
  tempCommunicationChairError: boolean;
  tempBannerError: boolean;
  tempExecutiveSponserError: boolean;

  DisableChair: boolean;
  DisableViceChair: boolean;
  DisableFinanceChair: boolean;
  DisableCommunicationChair: boolean;

  bannerFileName = "";
  sponserFileName: string = null;
  chairFileName = "";
  viceChairFileName = "";
  financeChairFileName = "";
  communicationFileName = "";
  method: string;
  param: string;
  msg1: string;
  showReset = false;
  firstEdit = false;
  timeOutError: boolean;
  timeoutErrorMessage: string = ConstantValues.timeoutErrorMessage;

  adminId: any = localStorage.getItem('adminId');
  loginData: any = JSON.parse(localStorage.getItem('loginData'));
  userId: any = this.loginData['userId'];
  userAndRoleIdDTO: any
  butDisabled = false;
  chapterList: any;
  landingDto1: any;

  //Image Cropper
  imageChangedEvent: any = '';
  croppedImage: any = '';

  isUploadBannerImage = false;
  uploadBannerImageDone = false;
  isUploadBannerLoaderStop = false;

  isUploadExecutiveSponsorImage = false;
  uploadExecutiveSponsorImageDone = false;
  isUploadExecutiveSponsorLoaderStop = false;

  isUploadChairImage = false;
  uploadChairImageDone = false;
  isUploadChairLoaderStop = false;

  isUploadViseChairImage = false;
  uploadViseChairImageDone = false;
  isUploadViseChairLoaderStop = false;

  isUploadFinanceChairImage = false;
  uploadFinanceChairImageDone = false;
  isUploadFinanceChairLoaderStop = false;

  isUploadCommunicationChairImage = false;
  uploadCommunicationChairImageDone = false;
  isUploadCommunicationChairLoaderStop = false;

  imageTypeName: string = null;
  isUploadAllImageDone: boolean;

  sponserPronoun = '';
  chairPronoun = '';
  viceChairPronoun = '';
  financeChairPronoun = '';
  communicationChairPronoun = '';

  chapterEmailInvalid = false;
  removeToolbar: any = { toolbar: 'Basic', uiColor: '#FFFFFF', basicEntities: false, fillEmptyBlocks: false, removeButtons: 'Source,Save,NewPage,Preview,Print,Templates,Pasteas plain text,PastefromWord,Find,Replace,SelectAll,Form,Checkbox,Radio,TextField,Textarea,SelectionField,Button,ImageButton,HiddenField,Italic,Decrease,Increase,Block,Create Div Container,Text direction from left to right,Text direction from right to left,Set language,Link,Unlink,Image,Flash,Table,Horizontal,Smiley,Insert Special Character,Insert Page Break for Printing,IFrame,Formatting,Paragraph,Font,FontSize,TextColor,BackgroundColor,Maximize,ShowBlocks,About,forceSpellChecker,Cut,Copy,Paste,Undo,Redo,Anchor,Underline,Strike,Subscript,Superscript,Bold,RemoveFormat' };
  //chapter board
  chapterBoardSearch: boolean;
  noUserChapterBoard: boolean;
  userFoundChapterBoard: boolean;
  chapterBoardMemberSuccess = false;
  deleteChapterBoardMember = false;
  butDisabledChapterBoard: boolean;
  chapterBoardImageTypeName: string = null;
  imageChangedEventChapterBoard: any = '';
  croppedImageChapterBoard: any;
  errorMessageChapterBoard: any;
  errorMessageActiveChapterBoard = false;
  searchKeyChapterBoard: any;
  currentPageChapterBoard = 1;
  tableShowChapterBoard: boolean;
  numberOfElementsChapterBoard: any;
  limitChapterBoard: number = ConstantValues.pageLimit;
  LandingPaginationDTO: { filter: { leadershipPosition: string; }; moduleId: number; page: number; presentRole: string; searchTerm: any; size: number; sortDirection: string; sortProperty: string; uid: string; };
  searchTerm: any;
  userList: any;
  userFirstName: string;
  designation: string;
  emailId: string;
  uploadFileTypeConstant = 'JPEG or PNG';
  uploadFileNameUser: string = this.uploadFileTypeConstant;
  saveAndUpdateBoard = false;
  chapterMemberSuccess = false;
  chapterBoardEmailValid = false;
  uploadFileExtensionUser = false;
  uploadUserPicImageDone = false;
  isLoaderUserPicStop = false;
  isUploadUserPicImage = false;
  chapterUserImage: string = null;
  chapterFlag = 'saveBoard';
  chapterBoardId: string;
  teamOrder: number;
  pronoun: string;
  deleteMember = false;
  firstEditChapterTeam = true;
  memberPic: any;
  userPic: string;
  saveBoard = true;
  chapterBoardList: any;
  currentShowingElementsReTeam: number = ConstantValues.pageLimit;
  name: string;
  showSecondTab = false;
  showFirstTab = false;
  isChapterExist = false;
  isbpgAdmin = false;
  isbpgLeadAdmin = false;
  ischapterEdit = false;
  userListForExecSponser: any = [];
  dataToggleConstant = 'data-toggle';
  dataTargetConstant = 'data-target';
  msg1Constant = " Your current changes will be discarded, do you want to continue ? ";
  fileTypeConstant = "image/jpeg";

  constructor(private readonly userService: SelfService, private readonly  bpgChapterService: BpgChapterHomePageService,  private readonly router: Router,
    private readonly spinner: Ng4LoadingSpinnerService,
    private readonly bpgEventsService: BpgEventsService,
    private readonly environment: EnvironmentConfiguration,
    private readonly dialog: MatDialog,
    private readonly bpgCommonService: BpgCommonService
    ) {
  }

  ngOnInit() {
    if (this.environment.envName === 'dev' || this.environment.envName === 'qa' || this.environment.envName === 'prod') {
              if (localStorage.getItem('loginData')=== null || localStorage.getItem('loginData')=== undefined) {

        this.router.navigate(['/log-out']);
      }
    }

    if (localStorage.getItem('logOutFlag') === "true") {
      this.router.navigate(['/log-out']);
    }
    if(localStorage.getItem('isbpgAdmin') === 'true')
    {
      this.isbpgAdmin = true
}
   if(localStorage.getItem('isbpgLeadAdmin') === 'true'){
     this.isbpgLeadAdmin = true;
   }
    this.userAndRoleIdDTO = {
      userId: this.loginData['userId'],
      roleId: localStorage.getItem('adminId')
    }
    
    if (this.adminId !== "1" && this.adminId !== "2" && this.adminId !== "3" && !this.isbpgAdmin && !this.isbpgLeadAdmin) {
      this.router.navigate(['/site-home']);
    }

    this.spinner.show();
    this.logUserAction();
    if (this.adminId === "2" || this.adminId === "3" || this.isbpgAdmin || this.isbpgLeadAdmin) {
      this.butDisabled = true;
    }

    this.bpgChapterService.bpgChapterData.subscribe(bpgChapterData => this.bpgChapterDetails = bpgChapterData)
    if (this.bpgChapterDetails != null) {
      this.bpgName = this.bpgChapterDetails[0]['bpgName'];
      this.visionStmt = this.bpgChapterDetails[0]['chapterVision'];
      this.missionStmt = this.bpgChapterDetails[0]['chapterMission'];
      this.imagePath = this.bpgChapterDetails[0]['chapterBanner'];
      this.chapterEmail = this.bpgChapterDetails[0]['chapterEmail'];
      this.bpgDate = this.bpgChapterDetails[0]['bpgDate'] ? new Date(this.bpgChapterDetails[0]['bpgDate']) : null;

    }

    if (this.adminId === "2" || this.adminId === "3" || this.isbpgAdmin || this.isbpgLeadAdmin) {
      this.bpgEventsService.getChapterDropDown(this.userAndRoleIdDTO).subscribe(data => {
        this.chapterList = data;
        this.chapterList.map((i) => { i.siteName = `${i.siteName}-${i.bpgName}`; return i; })
        for (let i = 0; i < this.chapterList.length; i++) {
          if (i === (this.chapterList.length - 1)) {
            this.chapterId = this.chapterId + this.chapterList[i].chapterId;
          } else {
            this.chapterId = `${this.chapterId}${this.chapterList[i].chapterId},`;
          }
        }

        this.landingDto = {
          "filter": { "chapterId": this.chapterId },
          "moduleId": 0,
          "page": 0,
          "presentRole": "",
          "searchTerm": "",
          "size": ConstantValues.pageLimit,
          "sortDirection": "ASC",
          "sortProperty": "",
          "uid": ""
        }
        this.spinner.show();
        this.listChapter();
      })
    }
    else {
      this.landingDto = {
        "filter": { "chapterId": this.chapterId },
        "moduleId": 0,
        "page": 0,
        "presentRole": "",
        "searchTerm": "",
        "size": ConstantValues.pageLimit,
        "sortDirection": "ASC",
        "sortProperty": "",
        "uid": ""
      }
      this.spinner.show();
      this.listChapter();
    }


    this.savebtn = true;

    this.loginUserId = this.loginData.userId;

    //To Find Current Time
    this.startDate = new Date().toISOString();
    this.userService.getAllSite().subscribe(data => {
      this.siteList = data;
      //filter default site from sitelist
      this.siteList = this.siteList.filter(site => site.locationCode !== 'DFLT');
    })
    this.getAllBpg();
    if (window.innerWidth < 767) {
      this.tableresp = true;
    } else {
      this.tableresp = false;
    }

    setTimeout(function () {
      this.spinner.hide();
    }.bind(this), 5000);
    this.siteName = "Select Site";
    this.bpgName = "Select ERG";
  }

  public setInactiveStatus() {
    this.setStatus = false;
  }
  public setActiveStatus() {
    this.setStatus = true;
  }
  public findBpgId(_$event, data) {
    for (const b of this.bpgList) {

      if (b.bpgName === data) {
        this.bpgId = b.bpgId;
        break;

      }
    }
    if (this.siteId !== '' && this.bpgId !== '') {

      this.getChapterStatus()

    }

  }
  public findSiteId(_$event, data) {
    for (const s of this.siteList) {

      if (s.siteName === data) {
        this.siteId = s.siteId;
        break;
      }
    }
    if (this.siteId !== '' && this.bpgId !== '') {
      this.getChapterStatus();
    }
  }

  findChairId(_$event, data) {
    for (const leader of this.leadershipChairList) {

      if (`${leader.userFirstName} ${leader.userLastName}` === data) {
        this.userId1 = leader.userId;
        break;
      }
    }

  }

  findViceChairId(_$event, data) {
    for (const vice of this.leadershipViceChairList) {
      if (`${vice.userFirstName} ${vice.userLastName}` === data) {
        this.userId2 = vice.userId;
        break;
      }
    }
  }

  findFinanceChairId(_$event, data) {
    for (const finance of this.leadershipFinanceChairList) {

      if (`${finance.userFirstName} ${finance.userLastName}` === data) {
        this.userId3 = finance.userId;
        break;
      }
    }
  }

  findCommunicationChairId(_$event, data) {
    for (const communication of this.leadershipCommunicationChairList) {

      if (`${communication.userFirstName} ${communication.userLastName}` === data) {
        this.userId4 = communication.userId;
        break;
      }
    }

  }
  getChapterStatus() {
    this.chapterBoardList = [];
    this.showFirstTab = true;
    this.showSecondTab = true;
    const sendData = {
      "siteId": this.siteId,
      "bpgId": this.bpgId
    }
    this.userService.getChapterStatus(sendData).subscribe(data => {
      if (data != null && data !== undefined){
        this.isChapterExist = data.isChapterExist
      }
      if (this.isChapterExist) {
        this.showFirstTab = true;
        this.showSecondTab = true;
        this.getChapterBoard();
      }
      else {
        this.showFirstTab = false;
        this.showSecondTab = false;
      }

    })
  }
  public onSubmit() {
    this.clearAlerts();
    if (this.editandSavebtn === true) {
      this.method = "save";
      this.param = '';
      this.msg1 = " Are you sure you want to update ? ";
    }
    else {
      this.method = "save";
      this.param = '';
      this.msg1 = " Are you sure you want to save ? ";
    }
  }
  openAndCloseMatDialog(type) {
    if (type === 'open') {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.height = "630px";
      dialogConfig.width = "800px";
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = false;
      this.dialog.open(this.callAPIDialog, dialogConfig);
    }
    else {
      this.dialog.closeAll();
      this.resetBoard();
    }

  }

  createChapterClick()
  {
    this.ischapterEdit = true;
  }
  /** For editing the chapter details
   * @method editChapter
   */
  createChair() {

    const landingDto = {
      "filter": {
        "siteId": this.siteId,
        "bpgId": this.bpgId,
        "leadershipPosition": "EMPLOYEE"
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "",
      "uid": ""
    }
    this.userService.getUserDropDown(landingDto).subscribe(data => {

      this.leadershipChairList = data;
      this.leadershipViceChairList = data;
      this.leadershipCommunicationChairList = data;
      this.leadershipFinanceChairList = data;
    })
  }

  userSelectionForExecSponser(e)
  {
  this.sponserName = `${e.userFirstName} ${e.userLastName}`;
  this.sponsorEmailId = e.emailId;
  }
  findbyEmail(e){
    const text = e.target.value;
    if(text.length>=4){
     this.searchTerm = text;
     this.searchByUser();
    }else{
      this.userListForExecSponser = [];
    }
  }
     /** For searching the table through search term
   * @class AdminComponent
   * @method searchBy
   */
     searchByUser() {
      this.spinner.show(); 
      const landingDto = {
        "filter": { 'leadershipPosition' : "USER"},
        "moduleId": 0,
        "page": 0,
        "presentRole": "string",
        "searchTerm":  (this.searchTerm) ? this.searchTerm : '',
        "size": ConstantValues.pageLimit,
        "sortDirection": "ASC",
        "sortProperty": "user_first_name",
        "uid": "string"
      }
    
      this.userService.getUserDropDown(landingDto).subscribe(
        (data) => {
          this.spinner.hide();   
          this.userListForExecSponser = data;
        })  
    }

  /** For editing the chapter details
   * @method editChapter
   */
  editChapter(data) {
    this.ischapterEdit = true;
    this.showSecondTab = true;
    this.showFirstTab = true;
    this.isChapterExist = true;
    this.showReset = true;
    this.viceChairEmailId = '';
    this.chairEmailId = '';
    this.financeChairEmailId = '';
    this.commChairEmailId = '';
    this.executiveSponsorImage = null;
    this.sponserName = null;
    this.sponsorEmailId = null;
    this.executiveSponser = null;
    if (this.sponser !== undefined) {
      this.sponser.innerText = this.uploadFileTypeConstant;
    }

    this.uploadPhotoChair = null;
    this.uploadPhotoChairImage = null;
    this.uploadPhotoViceChair = null;
    this.uploadPhotoViceChairImage = null;
    this.uploadPhotoFinanceChair = null;
    this.uploadPhotoFinanceChairImage = null;
    this.uploadPhotoCommunicationChair = null;
    this.uploadPhotoCommunicationChairImage = null;
    this.chapterEmailInvalid = false;
    this.userListForExecSponser = [];
    if (this.chair !== undefined) {
      this.chair.innerText = this.uploadFileTypeConstant;
    }
    if (this.viceChair !== undefined) {
      this.viceChair.innerText = this.uploadFileTypeConstant;
    }
    if (this.financeChair !== undefined) {
      this.financeChair.innerText = this.uploadFileTypeConstant;
    }
    if (this.communicationChair !== undefined) {
      this.communicationChair.innerText = this.uploadFileTypeConstant;
    }


    document.getElementById("base64textareaExecutiveSponser").textContent = '';

    this.resetChapter();

    this.banner = document.getElementById('bannerfilename');
    this.bannerFileName = data.chapterBanner;
    if (this.bannerFileName != null && this.bannerFileName.trim() !== "") {
      const b = this.bannerFileName.split('/');
      this.banner.innerText = b[1];
    }

    if (data.chaptersExecutiveSponsor != null && data.chaptersExecutiveSponsor.length > 0) {
      this.sponserName = data.chaptersExecutiveSponsor[0].executiveSponsorName;
      this.sponsorEmailId = data.chaptersExecutiveSponsor[0].executiveSponsorEmailId;
      this.sponser = document.getElementById('executiveSponserfilename');
      this.sponserFileName = data.chaptersExecutiveSponsor[0].userPic;
      this.sponserPronoun = data.chaptersExecutiveSponsor[0].executiveSponsorPronounce;
      if (this.sponserFileName != null && this.sponserFileName.trim() !== "") {
        const a = this.sponserFileName.split('/');
        this.sponser.innerText = a[1];
      }
    }

    if (data.chaptersLeadership != null && data.chaptersLeadership.length > 0) {
      for (const leader of data.chaptersLeadership) {
        if (leader != null && leader !== undefined) {
          if (leader.positionName === 'CHAIR') {
            this.chair = document.getElementById('chairfilename');
            this.uploadFileName = leader.userPic;
            this.chairEmailId = leader.emailAddress;
            this.chairPronoun = leader.leadershipPronounce;
            if (this.uploadFileName != null && this.uploadFileName !== undefined && this.uploadFileName !== "") {
              const b = this.uploadFileName.split('/');
              this.chair.innerText = b[1];
              this.chairFileName = b[1]
            }
          } else if (leader.positionName === 'VICE CHAIR') {
            this.viceChair = document.getElementById('vicechairfilename');
            this.uploadFileName = leader.userPic;
            this.viceChairEmailId = leader.emailAddress;
            this.viceChairPronoun = leader.leadershipPronounce;
            if (this.uploadFileName != null && this.uploadFileName !== undefined && this.uploadFileName !== "") {
              const b = this.uploadFileName.split('/');
              this.viceChair.innerText = b[1];
              this.viceChairFileName = b[1]
            }
          } else if (leader.positionName === 'FINANCE CHAIR') {
            this.financeChair = document.getElementById('financechairfilename');
            this.uploadFileName = leader.userPic;
            this.financeChairEmailId = leader.emailAddress;
            this.financeChairPronoun = leader.leadershipPronounce;
            if (this.uploadFileName != null && this.uploadFileName !== undefined && this.uploadFileName !== "") {
              const b = this.uploadFileName.split('/');
              this.financeChair.innerText = b[1];
              this.financeChairFileName = b[1]
            }
          } else if (leader.positionName === 'COMMUNICATION CHAIR') {
            this.communicationChair = document.getElementById('communicationchairfilename');
            this.uploadFileName = leader.userPic;
            this.commChairEmailId = leader.emailAddress;
            this.communicationChairPronoun = leader.leadershipPronounce;
            if (this.uploadFileName != null && this.uploadFileName !== undefined && this.uploadFileName !== "") {
              const b = this.uploadFileName.split('/');
              this.communicationChair.innerText = b[1];
              this.communicationFileName = b[1]
            }
          }
        }
      }
    }


    //Set bpg
    for (const bpg of this.bpgList) {
      if (bpg.bpgId === data.bpgId) {
        data.bpgName = bpg.bpgName
        break;
      }
    }

    //set site
    for (const site of this.siteList) {
      if (site.siteId === data.siteId) {
        data.siteName = site.siteName
        break;
      }
    }


    this.chapterBannerImage = data.chapterBannerImage;
    this.endDate = data.endDate;

    this.chapterId = data.chapterId;
    this.bpgName = data.bpgName;
    this.bpgId = data.bpgId;
    this.siteName = data.siteName;
    this.siteId = data.siteId;
    this.startDate = data.startDate;
    this.chapterEmail = data.chapterEmail;
    this.bpgDate = data.bpgDate ? new Date(data.bpgDate.replace('-', '/')) : null;

    this.chapterVision = data.chapterVision;
    this.chapterMission = data.chapterMission;


    this.userId1 = null;
    this.userId2 = null;
    this.userId3 = null;
    this.userId4 = null;

    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    this.editandSavebtn = true;
    this.savebtn = false;

    this.getLeadershipChairList();

    //set leadership
    if (data.chaptersLeadership != null) {

      for (const chapterLeader of data.chaptersLeadership) {

        const position = chapterLeader.positionName;
        switch (position) {
          //set chair
          case ConstantValues.leadershipPosition.chair:
            this.userId1 = chapterLeader.userId;
            for (const chair of this.leadershipChairList) {
              if (chair.userId === this.userId1) {
                data.userName = `${chair.userFirstName} ${chair.userLastName}`;
                this.selectMemberChair = `${chair.userFirstName} ${chair.userLastName}`;

              }
            }
            break;

          //set vice chair
          case ConstantValues.leadershipPosition.viceChair:
            this.userId2 = chapterLeader.userId;
            for (const viceChair of this.leadershipViceChairList) {
              if (viceChair.userId === this.userId2) {
                data.userName = `${viceChair.userFirstName} ${viceChair.userLastName}`;
                this.selectMemberViceChair = `${viceChair.userFirstName} ${viceChair.userLastName}`;

              }
            }
            break;
          //set finance chair
          case ConstantValues.leadershipPosition.financeChair:
            this.userId3 = chapterLeader.userId;
            for (const financeChair of this.leadershipFinanceChairList) {
              if (financeChair.userId === this.userId3) {
                data.userName = `${financeChair.userFirstName} ${financeChair.userLastName}`;
                this.selectMemberFinanceChair = `${financeChair.userFirstName} ${financeChair.userLastName}`;

              }
            }
            break;
          //set  communication Chair
          case ConstantValues.leadershipPosition.communicationChair:
            this.userId4 = chapterLeader.userId;
            for (const communicationChair of this.leadershipCommunicationChairList) {
              if (communicationChair.userId === this.userId4) {
                data.userName = `${communicationChair.userFirstName} ${communicationChair.userLastName}`;
                this.selectMemberCommunicationChair = `${communicationChair.userFirstName} ${communicationChair.userLastName}`;
              }
            }
            break;
        }
      }
    }
    document.getElementById("bpgName").setAttribute("disabled", "true");
    document.getElementById("siteName").setAttribute("disabled", "true");
    setTimeout(() => {
      this.getChapterBoard();
    }, 3000);
  }
  /** For deleting user picture
    * @method removeFile
    */
  removeFile(value) {
    this.clearAlerts();
    this.method = "removeFileClick";
    this.param = value;
    this.msg1 = " Are you sure you want to delete the user image ? ";
  }

  removeFileClick(value) {
    if (value === 'executiveSponser') {
      this.executiveSponsorImage = null;
      this.sponserFileName = null;
      document.getElementById("base64textareaExecutiveSponser").textContent = '';
      this.uploadExecutiveSponserFileExtension = false;
      this.myInputExecutiveSponserImageVariable.nativeElement.value = '';
      this.uploadExecutiveSponsorImageDone = false;
      document.getElementById("executiveSponserfilename").textContent = this.uploadFileTypeConstant;
      this.sponserFileName = null;
      this.isUploadExecutiveSponsorImage = false;
      this.isUploadExecutiveSponsorLoaderStop = false;
    }
    else if (value === 'chairfilename') {
      this.uploadPhotoChair = null;
      this.uploadPhotoChairImage = null;
      this.chair.innerText = this.uploadFileTypeConstant;
      document.getElementById("base64textareaChair").textContent = '';
      this.uploadLeadershipChairFileExtension = false;
      this.uploadChairImageDone = false;
      this.myInputChairImageVariable.nativeElement.value = '';
      document.getElementById("chairfilename").textContent = this.uploadFileTypeConstant;
      this.chairFileName = "";
      this.isUploadChairImage = false;
      this.isUploadChairLoaderStop = false;
    }
    else if (value === 'viceChairImage') {
      this.uploadPhotoViceChair = null;
      this.uploadPhotoViceChairImage = null;
      this.viceChair.innerText = this.uploadFileTypeConstant;
      document.getElementById("base64textareaViceChair").textContent = '';
      this.uploadLeadershipViceChairFileExtension = false;
      this.uploadViseChairImageDone = false;
      this.myInputViseChairImageVariable.nativeElement.value = '';
      document.getElementById("vicechairfilename").textContent = this.uploadFileTypeConstant;
      this.viceChairFileName = "";
      this.isUploadViseChairImage = false;
      this.isUploadViseChairLoaderStop = false;
    }
    else if (value === 'financeChairImage') {
      this.uploadPhotoFinanceChair = null;
      this.uploadPhotoFinanceChairImage = null;
      this.financeChair.innerText = this.uploadFileTypeConstant;
      document.getElementById("base64textareaFinanceChair").textContent = '';
      this.uploadLeadershipFinanceChairFileExtension = false;
      this.myInputFinanceChairImageVariable.nativeElement.value = '';
      this.uploadFinanceChairImageDone = false;
      document.getElementById("financechairfilename").textContent = this.uploadFileTypeConstant;
      this.financeChairFileName = "";
      this.isUploadFinanceChairImage = false;
      this.isUploadFinanceChairLoaderStop = false;
    }
    else if (value === 'communicationChairImage') {
      this.uploadPhotoCommunicationChair = null;
      this.uploadPhotoCommunicationChairImage = null;
      this.communicationChair.innerText = this.uploadFileTypeConstant;
      document.getElementById("base64textareaCommunicationChair").textContent = '';
      this.uploadLeadershipCommunicationChairFileExtension = false;
      this.uploadCommunicationChairImageDone = false;
      this.myInputCommunicationChairImageVariable.nativeElement.value = '';
      document.getElementById("communicationchairfilename").textContent = this.uploadFileTypeConstant;
      this.communicationFileName = "";
      this.isUploadCommunicationChairImage = false;
      this.isUploadCommunicationChairLoaderStop = false;
    }
  }
  edit(data, i) {
    if(this.adminId === '1'){
    this.clearAlerts();
    this.editChapter(data);
    if (this.firstEdit === false) {
      this.firstEdit = true;
      this.editChapter(data);
    } else {
      document.getElementById('edit' + i).setAttribute(this.dataToggleConstant, 'modal');
      document.getElementById('edit' + i).setAttribute(this.dataTargetConstant, '#myModal');
      this.method = "editChapter";
      this.param = data;
      this.msg1 = this.msg1Constant;
    }
  } else{
    this.editChapter(data);
  }
  }

    /** For cancelling the chapter edit 
   * @method cancelChapter
   */
  cancelChapter()
  {
    this.ischapterEdit = false; 
  }
  /** For resetting the chapter details
   * @method editChapter
   */
  resetChapter() {
    this.clearAlerts();
    this.method = "onResetClick";
    this.param = '';
    this.msg1 = this.msg1Constant;
  }

  onResetClick() {
    if (this.adminId === '2' || this.adminId === '3' || this.isbpgAdmin || this.isbpgLeadAdmin) {
      this.butDisabled = true;
    }
    else {
      document.getElementById("bpgName").removeAttribute("disabled");
      document.getElementById("siteName").removeAttribute("disabled");
    }
    this.chapterEmailInvalid = false
    this.chapterId = '0';
    this.chapterBannerImage = null;
    this.executiveSponsorImage = null;
    this.sponserName = null;
    this.sponsorEmailId = null;
    this.startDate = "";
    this.endDate = "";
    this.chapterEmail = null;
    this.bpgDate = null;
    this.chapterVision = "";
    this.chapterMission = "";

    this.chapterBanner = null;
    this.executiveSponser = null;
    this.sponserFileName = null;

    this.userId1 = null;
    this.uploadPhotoChair = null;
    this.uploadPhotoChairImage = null;

    this.userId2 = null;
    this.uploadPhotoViceChair = null;
    this.uploadPhotoViceChairImage = null;

    this.userId3 = null;
    this.uploadPhotoFinanceChair = null;
    this.uploadPhotoFinanceChairImage = null;

    this.userId4 = null;
    this.uploadPhotoCommunicationChair = null;
    this.uploadPhotoCommunicationChairImage = null;

    this.uploadFileExtension = false;
    this.uploadFileBannerExtension = false;
    this.uploadLeadershipChairFileExtension = false;
    this.uploadLeadershipViceChairFileExtension = false;
    this.uploadLeadershipFinanceChairFileExtension = false;
    this.uploadLeadershipCommunicationChairFileExtension = false;
    this.uploadExecutiveSponserFileExtension = false;

    this.sponserPronoun = '';
    this.chairPronoun = '';
    this.financeChairPronoun = '';
    this.viceChairPronoun = '';
    this.communicationChairPronoun = '';

    this.editandSavebtn = false;
    this.savebtn = true;
    this.searchKey = null;
    this.landingDto.searchTerm = null;
    for (let i = 0; i < this.chapterData.length; i++) {
      document.getElementById('edit' + i).removeAttribute(this.dataToggleConstant);
      document.getElementById('edit' + i).removeAttribute(this.dataTargetConstant);
    }
    this.firstEdit = false;
    if (this.banner !== undefined) {
      this.banner.innerText = this.uploadFileTypeConstant;
    }
    if (this.chair !== undefined) {
      this.chair.innerText = this.uploadFileTypeConstant;
    }
    if (this.viceChair !== undefined) {
      this.viceChair.innerText = this.uploadFileTypeConstant;
    }
    if (this.financeChair !== undefined) {
      this.financeChair.innerText = this.uploadFileTypeConstant;
    }
    if (this.communicationChair !== undefined) {
      this.communicationChair.innerText = this.uploadFileTypeConstant;
    }
    if (this.sponser !== undefined) {
      this.sponser.innerText = this.uploadFileTypeConstant;
    }
    document.getElementById("base64textarea").textContent = '';
    document.getElementById("base64textareaExecutiveSponser").textContent = '';
    document.getElementById("base64textareaChair").textContent = '';
    document.getElementById("base64textareaViceChair").textContent = '';
    document.getElementById("base64textareaFinanceChair").textContent = '';
    document.getElementById("base64textareaCommunicationChair").textContent = '';
    this.bpgName = "Select ERG";
    this.siteName = "Select Site";

    this.chairEmailId = null;
    this.viceChairEmailId = null;
    this.financeChairEmailId = null;
    this.commChairEmailId = null;

    this.listChapter();
    this.uploadBannerImageDone = false;
    this.uploadViseChairImageDone = false;
    this.uploadChairImageDone = false;
    this.uploadFinanceChairImageDone = false;
    this.uploadCommunicationChairImageDone = false;
    this.uploadExecutiveSponsorImageDone = false;
    this.myInputBannerImageVariable.nativeElement.value = '';
    this.myInputChairImageVariable.nativeElement.value = '';
    this.myInputViseChairImageVariable.nativeElement.value = '';
    this.myInputFinanceChairImageVariable.nativeElement.value = '';
    this.myInputCommunicationChairImageVariable.nativeElement.value = '';
    this.myInputExecutiveSponserImageVariable.nativeElement.value = '';
    this.imageChangedEvent = '';
    this.croppedImage = '';
    this.uploadFileName = '';
    this.uploadFileExtension = false;
    document.getElementById("bannerfilename").textContent = this.uploadFileTypeConstant;
    this.bannerFileName = null;
    this.isUploadBannerImage = false;
    this.isUploadBannerLoaderStop = false;
    document.getElementById("chairfilename").textContent = this.uploadFileTypeConstant;
    this.chairFileName = null;
    this.isUploadChairImage = false;
    this.isUploadChairLoaderStop = false;
    document.getElementById("vicechairfilename").textContent = this.uploadFileTypeConstant;
    this.viceChairFileName = null;
    this.isUploadViseChairImage = false;
    this.isUploadViseChairLoaderStop = false;
    document.getElementById("financechairfilename").textContent = this.uploadFileTypeConstant;
    this.financeChairFileName = null;
    this.isUploadFinanceChairImage = false;
    this.isUploadFinanceChairLoaderStop = false;
    document.getElementById("communicationchairfilename").textContent = this.uploadFileTypeConstant;
    this.communicationFileName = null;
    this.isUploadCommunicationChairImage = false;
    this.isUploadCommunicationChairLoaderStop = false;
    document.getElementById("executiveSponserfilename").textContent = this.uploadFileTypeConstant;
    this.sponserFileName = null;
    this.isUploadExecutiveSponsorImage = false;
    this.isUploadExecutiveSponsorLoaderStop = false;

    this.isUploadAllImageDone = false;

  }

  /** For listing the chapter details
   * @method listChapter
   */
  listChapter() {
    this.userService.getFullChapterList(this.landingDto).subscribe(data => {
      this.chapterData = data.content;
      this.tableShow = true;
      this.numberOfElements = data.totalElements;
      if (this.chapterData.length === 0) {
        this.tableShow = false;
        this.noDataFound = true;
      } else {
        this.tableShow = true;
        this.noDataFound = false;
        setTimeout(function () {
          this.spinner.hide();
        }.bind(this), 5000);
      }
    })

  }

  /** For filtering data by current page
   * @class ChapterComponent
   * @method pageChanged
   * @params event
   */
  pageChanged(event) {
    this.clearAlerts();
    this.landingDto.page = event - 1;
    this.currentPage = event;

    if ((this.currentPage * this.limit) < this.numberOfElements) {
      this.currentShowingElements = this.currentPage * this.limit;
    } else if ((this.currentPage * this.limit) >= this.numberOfElements) {
      this.currentShowingElements = this.numberOfElements;
    }
    this.listChapter();
  }

  /** For searching the table through keywords
   * @class ChapterComponent
   * @method searchMe
   */
  searchMe() {
    this.clearAlerts();
    this.spinner.show();
    this.searchKey = (this.searchKey) ? this.searchKey : '';
    this.landingDto.page = 0;
    this.landingDto.searchTerm = this.searchKey;
    this.currentPage = 1;
    this.listChapter();
    this.spinner.hide();
  }

  /** For sorting the table through columns
   * @class SiteComponent
   * @method sortMe
   */

  public sortMe(sortingby) {
    this.clearAlerts();
    if (this.landingDto.sortDirection === "ASC") {
      this.landingDto.sortDirection = "DESC";
      document.getElementById(sortingby + "1").classList.add("fading");
      document.getElementById(sortingby + "2").classList.remove("fading");
    } else {
      this.landingDto.sortDirection = "ASC";
      document.getElementById(sortingby + "2").classList.add("fading");
      document.getElementById(sortingby + "1").classList.remove("fading");
    }

    this.landingDto.sortProperty = sortingby;
    this.listChapter();
  }

  deleteChapter(data) {
    this.userService.deleteChapter(data.chapterId).subscribe(_data => {
      this.listChapter();
    })
  }

  /** For fetching leadership dropdowns
   * param siteId, positionName
   */
  //for Chair position
  getLeadershipChairList() {
    const landingDto = {
      "filter": {
        "siteId": this.siteId,
        "bpgId": this.bpgId,
        "leadershipPosition": "EMPLOYEE"
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "",
      "uid": ""
    }
    this.userService.getUserDropDown(landingDto).subscribe(data => {
      this.leadershipChairList = data;
      this.leadershipViceChairList = data;
      this.leadershipCommunicationChairList = data;
      this.leadershipFinanceChairList = data;
    })
  }

  //for viceChair position
  getLeadershipViceChairList() {
    const landingDto = {
      "filter": {
        "siteId": this.siteId,
        "bpgId": this.bpgId,
        "leadershipPosition": ConstantValues.leadershipPosition.viceChair
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "",
      "uid": ""
    }
    this.userService.getUserDropDown(landingDto).subscribe(data => {
      this.leadershipViceChairList = data;

    })
  }

  //for communicationChair position
  getLeadershipCommunicationChairList() {
    const landingDto = {
      "filter": {
        "siteId": this.siteId,
        "bpgId": this.bpgId,
        "leadershipPosition": ConstantValues.leadershipPosition.communicationChair
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "",
      "uid": ""
    }
    this.userService.getUserDropDown(landingDto).subscribe(data => {
      this.leadershipCommunicationChairList = data;

    })
  }

  //for financeChair position
  getLeadershipFinanceChairList() {
    const landingDto = {
      "filter": {
        "siteId": this.siteId,
        "bpgId": this.bpgId,
        "leadershipPosition": ConstantValues.leadershipPosition.financeChair
      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "",
      "uid": ""
    }
    this.userService.getUserDropDown(landingDto).subscribe(data => {
      this.leadershipFinanceChairList = data;

    })
  }

  /** email validation
* @class ChapterComponent
* @method checkEmailType
*/
  checkEmailType(event) {
    if (event.target.value !== "") {
      const re = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
      if (re.test(String(event.target.value).toLowerCase()) === false) {
        this.chapterEmailInvalid = true;
      }
      else {
        this.chapterEmailInvalid = false;
      }
    }
    else {
      this.chapterEmailInvalid = false;
    }
    this.enableTab('first');
  }
  /** Function that calls when image is loaded
   * param event, type
   */
  onSiteBannerSelected(event, type) {
    const files = event.target.files;
    const file = files[0];
    let imageData;
    let reader;
    switch (type) {
      case 'bannerImage': this.bannerFileName = file.name;
        break;
      case 'chairImage': this.chairFileName = file.name;
        break;
      case 'viceChairImage': this.viceChairFileName = file.name;
        break;
      case 'financeChairImage': this.financeChairFileName = file.name;
        break;
      case 'communicationChairImage': this.communicationFileName = file.name;
        break;
      case 'sponserImage': this.sponserFileName = file.name;
        break;


    }
    this.uploadFileName = file.name;
    this.imagecheck = file.type;
    /*Validation that uploaded file is of type image*/
    switch (type) {
      /*banner image check*/
      case 'bannerImage':
        if (file.type !== "image/png" && file.type !== this.fileTypeConstant) {
          this.flag1 = true;
        } else {
          this.flag1 = false;
        }
        break;
      /*leadership image check*/
      case 'chairImage':
        if (file.type !== "image/png" && file.type !== this.fileTypeConstant) {
          this.flag2 = true;
        } else {
          this.flag2 = false;
        }
        break;

      case 'viceChairImage':
        if (file.type !== "image/png" && file.type !== this.fileTypeConstant) {
          this.flag3 = true;
        } else {
          this.flag3 = false;
        }
        break;

      case 'financeChairImage':
        if (file.type !== "image/png" && file.type !== this.fileTypeConstant) {
          this.flag4 = true;
        } else {
          this.flag4 = false;
        }
        break;

      case 'communicationChairImage':
        if (file.type !== "image/png" && file.type !== this.fileTypeConstant) {
          this.flag5 = true;
        } else {
          this.flag5 = false;
        }
        break;

      /*executive sponser image check*/
      case 'sponserImage':
        if (file.type !== "image/png" && file.type !== this.fileTypeConstant) {
          this.flag6 = true;
        } else {
          this.flag6 = false;
        }
        break;
    }
    if ((this.flag1 || this.flag2 || this.flag3 || this.flag4 || this.flag5 || this.flag6) === true) {
      this.uploadFileExtension = true;
    }
    else {
      this.uploadFileExtension = false;
    }

    if (file.type === "image/png" || file.type === this.fileTypeConstant) {
      const image: any = event.target.files[0];
      const fr = new FileReader();
      fr.onload = () => { // when file has loaded
        const img: any = new Image();
        img.onload = () => {
          this.width = img.width;
          this.height = img.height;
          /*Validation for image size requirements*/
          switch (type) {
            /*banner image check*/
            case 'bannerImage':
              if (this.width < 1366) {
                this.uploadFileBannerExtension = true;
                this.tempBannerError = true;
              } else {
                this.uploadFileBannerExtension = false;
                this.tempBannerError = false;
              }
              break;
            /*leadership image check*/
            case 'chairImage':
              if (this.width === 400 && this.height === 400) {
                this.uploadLeadershipChairFileExtension = false;
                this.tempChairError = false;
              }
              else {
                this.uploadLeadershipChairFileExtension = true;
                this.tempChairError = true;
              }
              break;

            case 'viceChairImage':
              if (this.width === 400 && this.height === 400) {
                this.uploadLeadershipViceChairFileExtension = false;
                this.tempViceChairError = false;
              }
              else {
                this.uploadLeadershipViceChairFileExtension = true;
                this.tempViceChairError = true;
              }
              break;

            case 'financeChairImage':
              if (this.width === 400 && this.height === 400) {
                this.uploadLeadershipFinanceChairFileExtension = false;
                this.tempFinanceChairError = false;
              }
              else {
                this.uploadLeadershipFinanceChairFileExtension = true;
                this.tempFinanceChairError = true;
              }
              break;

            case 'communicationChairImage':
              if (this.width === 400 && this.height === 400) {
                this.uploadLeadershipCommunicationChairFileExtension = false;
                this.tempCommunicationChairError = false;
              }
              else {
                this.uploadLeadershipCommunicationChairFileExtension = true;
                this.tempCommunicationChairError = true;
              }
              break;

            case 'sponserImage':
              if (this.width === 400 && this.height === 400) {
                this.uploadExecutiveSponserFileExtension = false;
                this.tempExecutiveSponserError = false;
              }
              else {
                this.uploadExecutiveSponserFileExtension = true;
                this.tempExecutiveSponserError = true;
              }
              break;

            default: this.uploadFileExtension = false;
              break;

          }
        };
        img.src = fr.result; // This is the data URL

      };

      fr.readAsDataURL(image);
    }
    /*to set image and label*/
    switch (type) {
      case 'bannerImage':
        this.banner = document.getElementById('bannerfilename');
        this.banner.innerText = this.uploadFileName;
        if (files && file) {
          this.siteBannerImage = "";
          imageData = '';
          reader = new FileReader();

          if (reader.readAsBinaryString) {
            reader.onloadend = function (readerEvt: any) {
              const binaryString: any = readerEvt.target.result;
              imageData = btoa(binaryString);
              document.getElementById("base64textarea").textContent = imageData;
            };
            this.siteBannerImage = imageData;
            reader.readAsBinaryString(file);
          } else { // for IE 10 and 11

            let binary: any = "";
            const reader: any = new FileReader();
            reader.onload = function (e) {
              const bytes = new Uint8Array(e.target.result);
              const length = bytes.byteLength;
              for (let i = 0; i < length; i++) {
                binary += String.fromCharCode(bytes[i]);
              }
              //binary - readonly so assign content to another property
              imageData = btoa(binary);
              document.getElementById("base64textarea").textContent = imageData;
            }
            this.siteBannerImage = imageData;
            reader.readAsArrayBuffer(file);

          }
        }
        break;

      case 'chairImage':
        this.chair = document.getElementById('chairfilename');
        this.chair.innerText = this.uploadFileName;
        if (files && file) {
          this.siteBannerImage = "";
          imageData = '';
          reader = new FileReader();
          if (reader.readAsBinaryString) {
            reader.onloadend = function (readerEvt: any) {
              const binaryString: any = readerEvt.target.result;
              imageData = btoa(binaryString);
              document.getElementById("base64textareaChair").textContent = imageData;

            };
            this.siteBannerImage = imageData;
            reader.readAsBinaryString(file);
          } else { // for IE 10 and 11
            let binary: any = "";
            const reader: any = new FileReader();
            reader.onload = function (e) {
              const bytes = new Uint8Array(e.target.result);
              const length = bytes.byteLength;
              for (let i = 0; i < length; i++) {
                binary += String.fromCharCode(bytes[i]);
              }
              //binary - readonly so assign content to another property
              imageData = btoa(binary);
              document.getElementById("base64textareaChair").textContent = imageData;
            }
            this.siteBannerImage = imageData;
            reader.readAsArrayBuffer(file);
          }
        }
        break;

      case 'viceChairImage':
        this.viceChair = document.getElementById('vicechairfilename');
        this.viceChair.innerText = this.uploadFileName;
        if (files && file) {
          this.siteBannerImage = "";
          imageData = '';
          reader = new FileReader();
          if (reader.readAsBinaryString) {
            reader.onloadend = function (readerEvt: any) {
              const binaryString: any = readerEvt.target.result;
              imageData = btoa(binaryString);
              document.getElementById("base64textareaViceChair").textContent = imageData;

            };
            this.siteBannerImage = imageData;
            reader.readAsBinaryString(file);
          } else { // for IE 10 and 11
            let binary: any = "";
            const reader: any = new FileReader();
            reader.onload = function (e) {
              const bytes = new Uint8Array(e.target.result);
              const length = bytes.byteLength;
              for (let i = 0; i < length; i++) {
                binary += String.fromCharCode(bytes[i]);
              }
              //binary - readonly so assign content to another property
              imageData = btoa(binary);
              document.getElementById("base64textareaViceChair").textContent = imageData;
            }
            this.siteBannerImage = imageData;
            reader.readAsArrayBuffer(file);
          }
        }
        break;

      case 'financeChairImage':
        this.financeChair = document.getElementById('financechairfilename');
        this.financeChair.innerText = this.uploadFileName;
        if (files && file) {
          this.siteBannerImage = "";
          imageData = '';
          reader = new FileReader();
          if (reader.readAsBinaryString) {
            reader.onloadend = function (readerEvt: any) {
              const binaryString: any = readerEvt.target.result;
              imageData = btoa(binaryString);
              document.getElementById("base64textareaFinanceChair").textContent = imageData;

            };
            this.siteBannerImage = imageData;
            reader.readAsBinaryString(file);
          } else { // for IE 10 and 11
            let binary: any = "";
            const reader: any = new FileReader();
            reader.onload = function (e) {
              const bytes = new Uint8Array(e.target.result);
              const length = bytes.byteLength;
              for (let i = 0; i < length; i++) {
                binary += String.fromCharCode(bytes[i]);
              }
              //binary - readonly so assign content to another property
              imageData = btoa(binary);
              document.getElementById("base64textareaFinanceChair").textContent = imageData;
            }
            this.siteBannerImage = imageData;
            reader.readAsArrayBuffer(file);
          }
        }
        break;

      case 'communicationChairImage':
        this.communicationChair = document.getElementById('communicationchairfilename');
        this.communicationChair.innerText = this.uploadFileName;
        if (files && file) {
          this.siteBannerImage = "";
          imageData = '';
          reader = new FileReader();
          if (reader.readAsBinaryString) {
            reader.onloadend = function (readerEvt: any) {
              const binaryString: any = readerEvt.target.result;
              imageData = btoa(binaryString);
              document.getElementById("base64textareaCommunicationChair").textContent = imageData;

            };
            this.siteBannerImage = imageData;
            reader.readAsBinaryString(file);
          } else { // for IE 10 and 11
            let binary: any = "";
            const reader: any = new FileReader();
            reader.onload = function (e) {
              const bytes = new Uint8Array(e.target.result);
              const length = bytes.byteLength;
              for (let i = 0; i < length; i++) {
                binary += String.fromCharCode(bytes[i]);
              }
              //binary - readonly so assign content to another property
              imageData = btoa(binary);
              document.getElementById("base64textareaCommunicationChair").textContent = imageData;
            }
            this.siteBannerImage = imageData;
            reader.readAsArrayBuffer(file);
          }
        }
        break;

      // for executive sponser image
      case 'sponserImage':
        this.sponser = document.getElementById('executiveSponserfilename');
        this.sponser.innerText = this.uploadFileName;
        if (files && file) {
          this.siteBannerImage = "";
          imageData = '';
          reader = new FileReader();

          if (reader.readAsBinaryString) {
            reader.onloadend = function (readerEvt: any) {
              const binaryString: any = readerEvt.target.result;
              imageData = btoa(binaryString);
              document.getElementById("base64textareaExecutiveSponser").textContent = imageData;
            };
            this.siteBannerImage = imageData;
            reader.readAsBinaryString(file);
          } else { // for IE 10 and 11

            let binary: any = "";
            const reader: any = new FileReader();
            reader.onload = function (e) {
              const bytes = new Uint8Array(e.target.result);
              const length = bytes.byteLength;
              for (let i = 0; i < length; i++) {
                binary += String.fromCharCode(bytes[i]);
              }
              //binary - readonly so assign content to another property
              imageData = btoa(binary);
              document.getElementById("base64textareaExecutiveSponser").textContent = imageData;
            }
            this.siteBannerImage = imageData;
            reader.readAsArrayBuffer(file);

          }
        }
        break;
    }
  }



  chairSelection(event) {
    this.userId1 = event.target.value;
    this.chairEmailId = '';
    this.invalidChairEmail = false;
    this.isChairEmailBlank = false;

    if (event.target.value !== undefined && event.target.value !== null && event.target.value !== '') {
      for (const chairList of this.leadershipChairList) {
        if (this.leadershipChairList != null) {
          if (this.userId1 === chairList.userId.toString()) {
            this.chairEmailId = chairList.emailId;
          }
        }
      }
    }

  }

  viceChairSelection(event) {
    this.userId2 = event.target.value;
    this.viceChairEmailId = '';
    this.invalidViceChairEmail = false;
    this.isViceEmailBlank = false;
    if (event.target.value !== undefined && event.target.value !== null && event.target.value !== '') {
      for (const viceList of this.leadershipViceChairList) {
        if (this.leadershipViceChairList != null) {
          if (this.userId2 === viceList.userId.toString()) {
            this.viceChairEmailId = viceList.emailId;
          }
        }
      }
    }

  }

  financeChairSelection(event) {
    this.userId3 = event.target.value;
    this.financeChairEmailId = '';
    this.isFinanceEmailBlank = false;
    this.invalidFinanceChairEmail = false;
    if (event.target.value !== undefined && event.target.value !== null && event.target.value !== '') {
      for (const financeList of this.leadershipFinanceChairList) {
        if (this.leadershipFinanceChairList != null) {
          if (this.userId3 === financeList.userId.toString()) {
            this.financeChairEmailId = financeList.emailId;
          }
        }
      }
    }


  }

  communicationChairSelection(event) {
    this.userId4 = event.target.value;
    this.commChairEmailId = '';
    this.isCommEmailBlank = false;
    this.invalidCommChairEmail = false;
    if (event.target.value !== undefined && event.target.value !== null && event.target.value !== '') {
      for (const communicationList of this.leadershipCommunicationChairList) {
        if (this.leadershipCommunicationChairList != null) {
          if (this.userId4 === communicationList.userId.toString()) {
            this.commChairEmailId = communicationList.emailId;
          }
        }
      }
    }

  }

  onEmailType(event, type) {
    const re = new RegExp(/^(?!\.)[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@(?!-)[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/);
    switch (type) {
      case ConstantValues.leadershipPosition.chair:
        this.invalidChairEmail = false;
        this.isChairEmailBlank = false;
        if (event.target.value != null && event.target.value !== '') {
          if (re.test(String(event.target.value).toLowerCase()) === false) {
            this.invalidChairEmail = true;
          } else {
            this.invalidChairEmail = false;
          }
        } else {
          this.isChairEmailBlank = false;
          if (this.userId1 != null && this.userId1 !== 'null') {
            this.isChairEmailBlank = true;
          }
        }
        break;

      case ConstantValues.leadershipPosition.viceChair:
        this.invalidViceChairEmail = false;
        this.isViceEmailBlank = false;
        if (event.target.value != null && event.target.value !== '') {
          if (re.test(String(event.target.value).toLowerCase()) === false) {
            this.invalidViceChairEmail = true;
          } else {
            this.invalidViceChairEmail = false;
          }
        } else {
          this.isViceEmailBlank = false;
          if (this.userId2 != null && this.userId2 !== 'null') {
            this.isViceEmailBlank = true;
          }
        }
        break;
      case ConstantValues.leadershipPosition.financeChair:
        this.isFinanceEmailBlank = false;
        this.invalidFinanceChairEmail = false;
        if (event.target.value != null && event.target.value !== '') {
          if (re.test(String(event.target.value).toLowerCase()) === false) {
            this.invalidFinanceChairEmail = true;
          } else {
            this.invalidFinanceChairEmail = false;
          }
        } else {
          this.isFinanceEmailBlank = false;
          if (this.userId3 != null && this.userId3 !== 'null') {
            this.isFinanceEmailBlank = true;
          }
        }
        break;
      case ConstantValues.leadershipPosition.communicationChair:
        this.isCommEmailBlank = false;
        this.invalidCommChairEmail = false;
        if (event.target.value != null && event.target.value !== '') {
          if (re.test(String(event.target.value).toLowerCase()) === false) {
            this.invalidCommChairEmail = true;
          } else {
            this.invalidCommChairEmail = false;
          }
        } else {
          this.isCommEmailBlank = false;
          if (this.userId4 != null && this.userId4 !== 'null') {
            this.isCommEmailBlank = true;
          }
        }
        break;
      case "EXECUTIVE":
        this.isSponsorEmailBlank = false;
        this.invalidExecutiveSponsorEmail = false;
        if (event.target.value != null && event.target.value !== '') {
          if (re.test(String(event.target.value).toLowerCase()) === false) {
            this.invalidExecutiveSponsorEmail = true;
          } else {
            this.invalidExecutiveSponsorEmail = false;
          }
        }
        
        break;
    }
  }


  getAllBpg() {
    const landingDto = {
      "filter": {},
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "",
      "uid": ""
    };
    this.userService.getAllBpg(landingDto).subscribe(data => {
      this.bpgList = data;
    })
  }
  findbyEmailId(e){
    const text = e.target.value;
    if(text.length>2){
     this.searchTerm = text;
     this.searchBy();
    }else{
      this.userList = [];
      this.userFoundChapterBoard = false;
    }
  }
  public hideErrorMessaage(value) {

    if (value === 'Banner') {
      if (this.tempChairError === true || this.tempChairError === false || this.tempChairError === undefined) {
        this.uploadLeadershipChairFileExtension = false;
      }

      if (this.tempViceChairError === true || this.tempViceChairError === false || this.tempViceChairError === undefined) {
        this.uploadLeadershipViceChairFileExtension = false;
      }

      if (this.tempCommunicationChairError === true || this.tempCommunicationChairError === false || this.tempCommunicationChairError === undefined) {
        this.uploadLeadershipCommunicationChairFileExtension = false;
      }

      if (this.tempFinanceChairError === true || this.tempFinanceChairError === false || this.tempFinanceChairError === undefined) {
        this.uploadLeadershipFinanceChairFileExtension = false;
      }

      if (this.tempExecutiveSponserError === true || this.tempExecutiveSponserError === false || this.tempExecutiveSponserError === undefined) {
        this.uploadExecutiveSponserFileExtension = false;
      }

      if (this.tempBannerError === true) {
        this.uploadFileBannerExtension = true;
      }
    }

    if (value === 'Vision') {
      if (this.tempChairError === true || this.tempChairError === false || this.tempChairError === undefined) {
        this.uploadLeadershipChairFileExtension = false;
      }

      if (this.tempViceChairError === true || this.tempViceChairError === false || this.tempViceChairError === undefined) {
        this.uploadLeadershipViceChairFileExtension = false;
      }

      if (this.tempCommunicationChairError === true || this.tempCommunicationChairError === false || this.tempCommunicationChairError === undefined) {
        this.uploadLeadershipCommunicationChairFileExtension = false;
      }

      if (this.tempFinanceChairError === true || this.tempFinanceChairError === false || this.tempFinanceChairError === undefined) {
        this.uploadLeadershipFinanceChairFileExtension = false;
      }

      if (this.tempExecutiveSponserError === true || this.tempExecutiveSponserError === false || this.tempExecutiveSponserError === undefined) {
        this.uploadExecutiveSponserFileExtension = false;
      }

      if (this.tempBannerError === true) {
        this.uploadFileBannerExtension = false;
      }
    }



    if (value === 'Leadership') {
      if (this.tempChairError === true) {
        this.uploadLeadershipChairFileExtension = true;
      } else {
        this.uploadLeadershipChairFileExtension = false;
      }

      if (this.tempViceChairError === true) {
        this.uploadLeadershipViceChairFileExtension = true;
      } else {
        this.uploadLeadershipViceChairFileExtension = false;
      }

      if (this.tempCommunicationChairError === true) {
        this.uploadLeadershipCommunicationChairFileExtension = true;
      } else {
        this.uploadLeadershipCommunicationChairFileExtension = false;
      }

      if (this.tempFinanceChairError === true) {
        this.uploadLeadershipFinanceChairFileExtension = true;
      } else {
        this.uploadLeadershipFinanceChairFileExtension = false;
      }

      if (this.tempExecutiveSponserError === true) {
        this.uploadExecutiveSponserFileExtension = true;
      } else {
        this.uploadExecutiveSponserFileExtension = false;
      }

      if (this.tempBannerError === true) {
        this.uploadFileBannerExtension = false;
      }
    }

  }

  public save() {
    this.timeOutError = false;
    if (this.startDate === null || this.startDate === "") {
      this.startDate = new Date().toISOString();
    }
    this.chapterBannerImage = document.getElementById("base64textarea").textContent;
    if (this.chapterBannerImage.length === 0) {
      this.chapterBannerImage = null;
    }
    this.executiveSponsorImage = document.getElementById("base64textareaExecutiveSponser").textContent;
    if (this.executiveSponsorImage.length === 0) {
      this.executiveSponsorImage = null;
    }
    this.uploadPhotoChairImage = document.getElementById("base64textareaChair").textContent;
    if (this.uploadPhotoChairImage.length === 0) {
      this.uploadPhotoChairImage = null;
    }
    this.uploadPhotoViceChairImage = document.getElementById("base64textareaViceChair").textContent;
    if (this.uploadPhotoViceChairImage.length === 0) {
      this.uploadPhotoViceChairImage = null;
    }
    this.uploadPhotoFinanceChairImage = document.getElementById("base64textareaFinanceChair").textContent;
    if (this.uploadPhotoFinanceChairImage.length === 0) {
      this.uploadPhotoFinanceChairImage = null;
    }
    this.uploadPhotoCommunicationChairImage = document.getElementById("base64textareaCommunicationChair").textContent;
    if (this.uploadPhotoCommunicationChairImage.length === 0) {
      this.uploadPhotoCommunicationChairImage = null;
    }
    const data = {

      "chaptersDTO": {
        "chapterId": this.chapterId,
        "bpgId": this.bpgId,
        "siteId": this.siteId,
        "startDate": this.startDate,
        "endDate": this.endDate,
        "chapterBanner": this.bannerFileName,
        "chapterMission": this.chapterMission,
        "chapterVision": this.chapterVision,
        "chapterEmail": this.chapterEmail,
        "bpgDate": this.bpgDate,
        "isActive": this.setStatus,
        "modifiedBy": "1",
        "createdBy": "1"
      },
      "chaptersLeadershipRequestDTO": [
      ],
      "chapterBannerImage": this.chapterBannerImage,
      "editAndSave": this.editandSavebtn,
      "executiveSponsorImage": this.executiveSponsorImage,
      "UserId": this.loginData['userId'],
      "chaptersExecutiveSponsorDTO": {
        "chapterExecutiveSponsorId": 0,
        "chapterId": this.chapterId,
        "executiveSponsorName": this.sponserName,
        "startDate": this.startDate,
        "endDate": this.endDate,
        "userPic": this.sponserFileName,
        "executiveSponsorEmailId": this.sponsorEmailId,
        "isActive": this.setStatus,
        "modifiedBy": "1",
        "createdBy": "1",
        "executiveSponsorPronounce": this.sponserPronoun
      }
    }

    data.chaptersLeadershipRequestDTO.push(

      {
        "createdBy": "1",
        "modifiedBy": "1",
        "createdDateTime": this.startDate,
        "modifiedDateTime": this.startDate,
        "isActive": this.setStatus,
        "chapterLeadershipId": 0,
        "chapterId": data.chaptersDTO.chapterId,
        "startDate": this.startDate,
        "endDate": this.endDate,
        "userPic": this.chairFileName,
        "positionName": ConstantValues.leadershipPosition.chair,
        "userId": this.userId1,
        "chapterLeaderImage": this.uploadPhotoChairImage,
        "emailAddress": this.chairEmailId,
        "leadershipPronounce": this.chairPronoun

      },

      {
        "createdBy": "1",
        "modifiedBy": "1",
        "createdDateTime": this.startDate,
        "modifiedDateTime": this.startDate,
        "isActive": this.setStatus,
        "chapterLeadershipId": 0,
        "chapterId": data.chaptersDTO.chapterId,
        "startDate": this.startDate,
        "endDate": this.endDate,
        "userPic": this.viceChairFileName,
        "positionName": ConstantValues.leadershipPosition.viceChair,
        "userId": this.userId2,
        "chapterLeaderImage": this.uploadPhotoViceChairImage,
        "emailAddress": this.viceChairEmailId,
        "leadershipPronounce": this.viceChairPronoun

      },

      {
        "createdBy": "1",
        "modifiedBy": "1",
        "createdDateTime": this.startDate,
        "modifiedDateTime": this.startDate,
        "isActive": this.setStatus,
        "chapterLeadershipId": 0,
        "chapterId": data.chaptersDTO.chapterId,
        "startDate": this.startDate,
        "endDate": this.endDate,
        "userPic": this.financeChairFileName,
        "positionName": ConstantValues.leadershipPosition.financeChair,
        "userId": this.userId3,
        "chapterLeaderImage": this.uploadPhotoFinanceChairImage,
        "emailAddress": this.financeChairEmailId,
        "leadershipPronounce": this.financeChairPronoun
      },

      {
        "createdBy": "1",
        "modifiedBy": "1",
        "createdDateTime": this.startDate,
        "modifiedDateTime": this.startDate,
        "isActive": this.setStatus,
        "chapterLeadershipId": 0,
        "chapterId": data.chaptersDTO.chapterId,
        "startDate": this.startDate,
        "endDate": this.endDate,
        "userPic": this.communicationFileName,
        "positionName": ConstantValues.leadershipPosition.communicationChair,
        "userId": this.userId4,
        "chapterLeaderImage": this.uploadPhotoCommunicationChairImage,
        "emailAddress": this.commChairEmailId,
        "leadershipPronounce": this.communicationChairPronoun
      }
    )



    this.spinner.show();
    this.userService.saveAllChapter(data).subscribe(data => {

      if (this.editandSavebtn === true) {
        this.spinner.hide();
        this.alertUpdate = true;
        if (this.adminId === '2' ||this.adminId === '3' || this.isbpgAdmin || this.isbpgLeadAdmin)
         {
          setTimeout(() => {
            this.alertUpdate = false;
            this.ischapterEdit = false;
            window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
          }, 1000);
        }
      } else {
        this.spinner.hide();
        /* Validation for duplicates */
        if (data === null) {
          this.alertFailure = true;
          return;
        }
        if (data.body != null && data.body.message !== undefined) {
          this.errorMessage = data.body.message;
          this.errorMessageActive = true;
        }
        this.alertSuccess = true;
      }
      if (data != null || data !== undefined) {
        this.chapterId = data.body.chaptersDTO.chapterId;
        document.getElementById("bpgName").setAttribute("disabled", "true");
        document.getElementById("siteName").setAttribute("disabled", "true");

      }
      this.listChapter();
      this.editandSavebtn = true;
      this.savebtn = false;

    }, err => {

      if (err.value.statusText === ConstantValues.unknownError) {
        this.spinner.hide();
        this.timeOutError = true;
      }


    })

    setTimeout(() => {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    }, 500);

  }

  //to clear all the alert messages
  clearAlerts() {
    this.leadershipChairDuplicateCheck = false;
    this.uploadFileExtension = false;
    this.uploadLeadershipChairFileExtension = false;
    this.uploadLeadershipViceChairFileExtension = false;
    this.uploadLeadershipFinanceChairFileExtension = false;
    this.uploadLeadershipCommunicationChairFileExtension = false;
    this.uploadExecutiveSponserFileExtension = false;
    this.visionBlankCheck = false;
    this.alertSuccess = false;
    this.alertFailure = false;
    this.alertUpdate = false;
    this.uploadFileBannerExtension = false;
    this.tempBannerError = false;
    this.tempChairError = false;
    this.tempViceChairError = false;
    this.tempFinanceChairError = false;
    this.tempCommunicationChairError = false;
    this.tempExecutiveSponserError = false;
    this.errorMessageActive = false;
    this.invalidChairEmail = false;
    this.invalidViceChairEmail = false;
    this.invalidFinanceChairEmail = false;
    this.invalidCommChairEmail = false;
    this.invalidExecutiveSponsorEmail = false;
    this.isChairEmailBlank = false;
    this.isViceEmailBlank = false;
    this.isFinanceEmailBlank = false;
    this.isCommEmailBlank = false;
    this.isSponsorEmailBlank = false;
  }

  fileChangeEvent(event: any, imageType): void {

    const files = event.target.files;
    const file = files[0];
    this.imageTypeName = imageType;
    if (file.type !== "image/png" && file.type !== this.fileTypeConstant) {
      this.uploadFileExtension = true;
      this.clearImageInputValue(imageType);
    } else {
      this.imageChangedEvent = event;
      this.uploadFileExtension = false;
      this.uploadFileName = file.name;
      if (imageType === "bannerImage") {
        this.isUploadBannerLoaderStop = false;
        this.bannerFileName = file.name;
        document.getElementById("bannerfilename").textContent = this.bannerFileName;
        this.uploadBannerImageDone = true;
        this.isUploadBannerImage = true;

      } else if (imageType === "chairImage") {
        this.isUploadChairLoaderStop = false;
        this.chairFileName = file.name;
        document.getElementById("chairfilename").textContent = this.chairFileName;
        this.uploadChairImageDone = true;
        this.isUploadChairImage = true;

      } else if (imageType === "viceChairImage") {
        this.isUploadViseChairLoaderStop = false;
        this.viceChairFileName = file.name;
        document.getElementById("vicechairfilename").textContent = this.viceChairFileName;
        this.uploadViseChairImageDone = true;
        this.isUploadViseChairImage = true;

      } else if (imageType === "financeChairImage") {
        this.isUploadFinanceChairLoaderStop = false;
        this.financeChairFileName = file.name;
        document.getElementById("financechairfilename").textContent = this.financeChairFileName;
        this.uploadFinanceChairImageDone = true;
        this.isUploadFinanceChairImage = true;

      } else if (imageType === "communicationChairImage") {
        this.isUploadCommunicationChairLoaderStop = false;
        this.communicationFileName = file.name;
        document.getElementById("communicationchairfilename").textContent = this.communicationFileName;
        this.uploadCommunicationChairImageDone = true;
        this.isUploadCommunicationChairImage = true;

      } else if (imageType === "sponserImage") {
        this.isUploadExecutiveSponsorLoaderStop = false;
        this.sponserFileName = file.name;
        document.getElementById("executiveSponserfilename").textContent = this.sponserFileName;
        this.uploadExecutiveSponsorImageDone = true;
        this.isUploadExecutiveSponsorImage = true;

      } 
    }

  }
  enableTab(val) {
    if (val === 'first') {
      if (this.bannerFileName != null && this.bannerFileName !== "" && !this.chapterEmailInvalid && this.chapterEmail != null) {
        this.showFirstTab = true;
      }
      else {
        this.showFirstTab = false;
      }
    }
    else if (val === 'second') {

      if (this.chapterMission != null && this.chapterMission !== "" && this.chapterVision != null && this.chapterVision !== "" && this.chapterVision.length <= 1024 && this.chapterMission.length <= 1024) {
        this.showSecondTab = true;
      }
      else {
        this.showSecondTab = false;
      }
    }
  }

  imageCropped(event: ImageCroppedEvent) {

    this.croppedImage = event.base64.replace(/^data:image\/[a-z]+;base64,/, "");
    if (this.imageTypeName === "bannerImage") {
      document.getElementById("base64textarea").textContent = this.croppedImage;
      this.uploadBannerImageDone = true;
    } else if (this.imageTypeName === "chairImage") {
      document.getElementById("base64textareaChair").textContent = this.croppedImage;
      this.uploadChairImageDone = true;
    } else if (this.imageTypeName === "viceChairImage") {
      document.getElementById("base64textareaViceChair").textContent = this.croppedImage;
      this.uploadViseChairImageDone = true;
    } else if (this.imageTypeName === "financeChairImage") {
      document.getElementById("base64textareaFinanceChair").textContent = this.croppedImage;
      this.uploadFinanceChairImageDone = true;
    } else if (this.imageTypeName === "communicationChairImage") {
      document.getElementById("base64textareaCommunicationChair").textContent = this.croppedImage;
      this.uploadCommunicationChairImageDone = true;
    } else if (this.imageTypeName === "sponserImage") {
      document.getElementById("base64textareaExecutiveSponser").textContent = this.croppedImage;
      this.uploadExecutiveSponsorImageDone = true;
    } 
    this.isUploadAllImageDone = true;
  }
  imageLoaded() {

    if (this.imageTypeName === "bannerImage") {
      this.isUploadBannerLoaderStop = true;
    } else if (this.imageTypeName === "chairImage") {
      this.isUploadChairLoaderStop = true;
    } else if (this.imageTypeName === "viceChairImage") {
      this.isUploadViseChairLoaderStop = true;
    } else if (this.imageTypeName === "financeChairImage") {
      this.isUploadFinanceChairLoaderStop = true;
    } else if (this.imageTypeName === "communicationChairImage") {
      this.isUploadCommunicationChairLoaderStop = true;
    } else if (this.imageTypeName === "sponserImage") {
      this.isUploadExecutiveSponsorLoaderStop = true;
    }
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }

  cancelUploadedImage(imageTypeName) {
    this.imageChangedEvent = '';
    this.croppedImage = '';
    this.uploadFileName = '';
    this.uploadFileExtension = false;
    if (imageTypeName === "bannerImage") {
      document.getElementById("base64textarea").textContent = '';
      document.getElementById("bannerfilename").textContent = this.uploadFileTypeConstant;
      this.bannerFileName = null;
      this.isUploadBannerImage = false;
      this.isUploadBannerLoaderStop = false;
      this.enableTab('first');
    } else if (imageTypeName === "chairImage") {
      document.getElementById("base64textareaChair").textContent = '';
      document.getElementById("chairfilename").textContent = this.uploadFileTypeConstant;
      this.chairFileName = null;
      this.isUploadChairImage = false;
      this.isUploadChairLoaderStop = false;
      this.uploadChairImageDone = false;

    } else if (imageTypeName === "viceChairImage") {
      document.getElementById("base64textareaViceChair").textContent = '';
      document.getElementById("vicechairfilename").textContent = this.uploadFileTypeConstant;
      this.viceChairFileName = null;
      this.isUploadViseChairImage = false;
      this.isUploadViseChairLoaderStop = false;
      this.uploadViseChairImageDone = false;

    } else if (imageTypeName === "financeChairImage") {
      document.getElementById("base64textareaFinanceChair").textContent = '';
      document.getElementById("financechairfilename").textContent = this.uploadFileTypeConstant;
      this.financeChairFileName = null;
      this.isUploadFinanceChairImage = false;
      this.isUploadFinanceChairLoaderStop = false;
      this.uploadFinanceChairImageDone = false;

    } else if (imageTypeName === "communicationChairImage") {
      document.getElementById("base64textareaCommunicationChair").textContent = '';
      document.getElementById("communicationchairfilename").textContent = this.uploadFileTypeConstant;
      this.communicationFileName = null;
      this.isUploadCommunicationChairImage = false;
      this.isUploadCommunicationChairLoaderStop = false;
      this.uploadCommunicationChairImageDone = false;

    } else if (imageTypeName === "sponserImage") {
      document.getElementById("base64textareaExecutiveSponser").textContent = '';
      document.getElementById("executiveSponserfilename").textContent = this.uploadFileTypeConstant;
      this.sponserFileName = null;
      this.isUploadExecutiveSponsorImage = false;
      this.isUploadExecutiveSponsorLoaderStop = false;
      this.uploadExecutiveSponsorImageDone = false;

    } 

    if (imageTypeName !== "bannerImage" && (this.uploadChairImageDone === true || this.uploadViseChairImageDone === true || this.uploadFinanceChairImageDone === true || this.uploadCommunicationChairImageDone === true || this.uploadExecutiveSponsorImageDone === true)) {
      this.isUploadAllImageDone = true;
    } else {
      this.isUploadAllImageDone = false;
    }

    this.clearImageInputValue(imageTypeName);

  }

  doneUploadedImage(imageTypeName) {
    this.uploadFileExtension = false;
    if (imageTypeName === "bannerImage") {
      this.isUploadBannerImage = false;
      this.uploadBannerImageDone = false;
      this.isUploadAllImageDone = false;
      this.isUploadBannerLoaderStop = false;
      this.enableTab('first');
    } else if (imageTypeName === "chairImage") {
      this.isUploadChairImage = false;
      this.uploadChairImageDone = false;
      this.isUploadChairLoaderStop = false;
    } else if (imageTypeName === "viceChairImage") {
      this.isUploadViseChairImage = false;
      this.uploadViseChairImageDone = false;
      this.isUploadViseChairLoaderStop = false;
    } else if (imageTypeName === "financeChairImage") {
      this.isUploadFinanceChairImage = false;
      this.uploadFinanceChairImageDone = false;
      this.isUploadFinanceChairLoaderStop = false;
    } else if (imageTypeName === "communicationChairImage") {
      this.isUploadCommunicationChairImage = false;
      this.uploadCommunicationChairImageDone = false;
      this.isUploadCommunicationChairLoaderStop = false;
    } else if (imageTypeName === "sponserImage") {
      this.isUploadExecutiveSponsorImage = false;
      this.uploadExecutiveSponsorImageDone = false;
      this.isUploadExecutiveSponsorLoaderStop = false;
    } 

    if (imageTypeName !== "bannerImage" && (this.uploadChairImageDone === true || this.uploadViseChairImageDone === true || this.uploadFinanceChairImageDone === true || this.uploadCommunicationChairImageDone === true || this.uploadExecutiveSponsorImageDone === true)) {
      this.isUploadAllImageDone = true;
    } else {
      this.isUploadAllImageDone = false;
    }

    this.clearImageInputValue(imageTypeName);
  }

  clearImageInputValue(imageTypeName) {
    if (imageTypeName === "bannerImage") {
      this.myInputBannerImageVariable.nativeElement.value = '';
    } else if (imageTypeName === "chairImage") {
      this.myInputChairImageVariable.nativeElement.value = '';
    } else if (imageTypeName === "viceChairImage") {
      this.myInputViseChairImageVariable.nativeElement.value = '';
    } else if (imageTypeName === "financeChairImage") {
      this.myInputFinanceChairImageVariable.nativeElement.value = '';
    } else if (imageTypeName === "communicationChairImage") {
      this.myInputCommunicationChairImageVariable.nativeElement.value = '';
    } else if (imageTypeName === "sponserImage") {
      this.myInputExecutiveSponserImageVariable.nativeElement.value = '';
    } 

    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
  }
  //chapterboard

  /** For searching the user
 * @class NaacComponent
 * @method searchBy
 */

  searchBy() {
    this.clearAlertsChapterBoard();
    this.spinner.show();
    this.chapterBoardSearch = true;
    this.errorMessageActiveChapterBoard = false;
    this.getUserList();
    this.spinner.hide();
  }
  /** to clear data
 * @class DIComponent
 * @method clearAlerts
 */
  clearAlertsChapterBoard() {
    this.noUserChapterBoard = false;
    this.userFoundChapterBoard = false;
  }

  /** to list users other than admins
  * @class naacComponent
  * @method getUserList
  */
  getUserList() {
    this.chapterBoardMemberSuccess = false;
    this.deleteChapterBoardMember = false;
    this.LandingPaginationDTO = {
      "filter": { leadershipPosition: "USER" },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": this.searchTerm,
      "size": 500,
      "sortDirection": "ASC",
      "sortProperty": "regionalOrder",
      "uid": ""
    }
    this.userService.getUserDropDown(this.LandingPaginationDTO).subscribe(data => {
      this.userList = data;
      if (this.userList.length === 0) {
        setTimeout(() => {
          window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 500);
        this.noUserChapterBoard = true;
        this.userFirstName = null
        this.emailId = null
        this.butDisabledChapterBoard = true;
      } else {
        this.butDisabledChapterBoard = false;
        if (this.chapterBoardSearch) {
          setTimeout(() => {
            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
          }, 500);
          this.userFoundChapterBoard = true;
        }
        this.userList.map((i) => { i.userFirstName = `${i.userFirstName} ${i.userLastName}`; return i; })
      }
    }, _err => {
    });


  }

  /** to select the user acc to search
  * @class naacComponent
  * @method userSelection
  */
  userSelection(user) {
    this.clearAlertsChapterBoard();
    for (const val of this.userList) {

      if (val != null) {
        if (user.userId === val.userId) {
          this.userId = val.userId;
          this.name = val.userFirstName;
          this.emailId = val.emailId;
          this.chapterBoardEmailValid = false;
        }
      }
    }

  }

  /** email validation
* @class NaacComponent
* @method onEmailType
*/
  onEmailTypeChapterBoard(event) {
    const re = new RegExp(/^(?!\.)[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@(?!-)[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/);
    if (re.test(String(event.target.value).toLowerCase()) === false) {
      if (this.butDisabledChapterBoard === false) {
        this.chapterBoardEmailValid = true;
      }
    }
    else {
      this.chapterBoardEmailValid = false;
    }
  }
  fileChangeEventChapterBoard(event: any, imageType): void {
    const files = event.target.files;
    const file = files[0];
    this.chapterBoardImageTypeName = imageType;
    if (file.type !== "image/png" && file.type !== this.fileTypeConstant) {

      this.uploadFileExtensionUser = true;
      this.myInputVariable.nativeElement.value = '';
    } else {
      this.imageChangedEventChapterBoard = event;
      this.uploadFileExtensionUser = false;
      this.uploadFileNameUser = file.name;
      document.getElementById("filenameUserPic").textContent = this.uploadFileNameUser;
      this.isLoaderUserPicStop = false;
      this.uploadUserPicImageDone = true;
      this.isUploadUserPicImage = true;

    }
  }
  imageCroppedChapterBoard(event: ImageCroppedEvent) {
    this.croppedImageChapterBoard = event.base64.replace(/^data:image\/[a-z]+;base64,/, "");
    document.getElementById("base64textareaUser").textContent = this.croppedImageChapterBoard;
    this.chapterUserImage = this.croppedImageChapterBoard;
    this.uploadUserPicImageDone = true;
  }

  imageLoadedChapterBoard() {
    this.isLoaderUserPicStop = true;
  }
  cropperReadyChapterBoard() {
    // cropper ready
  }
  loadImageFailedChapterBoard() {
    // show message
  }

  cancelUploadedImageChapterBoard(_imageType) {
    document.getElementById("base64textareaUser").textContent = '';
    document.getElementById("filenameUserPic").textContent = this.uploadFileTypeConstant;
    this.myInputVariable.nativeElement.value = '';
    this.uploadFileExtensionUser = false;
    this.chapterUserImage = null;
    this.uploadFileNameUser = this.uploadFileTypeConstant;
    this.isUploadUserPicImage = false;
    this.isLoaderUserPicStop = false;
    this.imageChangedEventChapterBoard = '';
    this.croppedImageChapterBoard = '';
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
  }

  doneUploadedImageChapterBoard(_imageType) {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });

    this.myInputVariable.nativeElement.value = '';
    this.uploadFileExtensionUser = false;
    this.uploadUserPicImageDone = false;
    this.isLoaderUserPicStop = false;
    this.isUploadUserPicImage = false;

  }

  /** to submit chapter member details
* @class chapterBoardComponent
* @method onChapterBoardSubmit
*/
  public onChapterBoardSubmit() {

    if (this.uploadFileExtensionUser === true) {
      this.removeModalReTeam();
      return;
    }
    if (this.saveAndUpdateBoard === true) {
      this.setModalReTeam();
      this.popupModalReTeam()
      document.getElementById('saveAndUpdateBoard').click();
    }
    else {
      this.setModalReTeam();
      this.popupModalReTeam()
      document.getElementById('saveBoard').click();
    }

  }


  popupModalReTeam() {
    if (this.saveAndUpdateBoard === true) {
      this.method = "addChapterBoard";
      this.param = '';
      this.msg1 = " Are you sure you want to update ? ";
    }
    else {
      this.method = "addChapterBoard";
      this.param = '';
      this.msg1 = " Are you sure you want to Save ? ";
    }
  }

  setModalReTeam() {
    if (this.saveAndUpdateBoard === true) {
      document.getElementById('saveAndUpdateBoard').setAttribute(this.dataToggleConstant, 'modal');
      document.getElementById('saveAndUpdateBoard').setAttribute(this.dataTargetConstant, '#myModal');
    } else {
      document.getElementById('saveBoard').setAttribute(this.dataToggleConstant, 'modal');
      document.getElementById('saveBoard').setAttribute(this.dataTargetConstant, '#myModal');
    }
  }
  removeModalReTeam() {
    if (this.saveAndUpdateBoard === true) {
      document.getElementById('saveAndUpdateBoard').removeAttribute(this.dataToggleConstant);
      document.getElementById('saveAndUpdateBoard').removeAttribute(this.dataTargetConstant);
    }
    else {
      document.getElementById('saveBoard').removeAttribute(this.dataToggleConstant);
      document.getElementById('saveBoard').removeAttribute(this.dataTargetConstant);

    }
  }
  addChapterBoard() {
    if (this.isChapterExist) {

      if (this.saveAndUpdateBoard === true) {
        this.chapterFlag = "saveAndUpdateBoard"
      }
      else {
        this.chapterFlag = "saveBoard";
        this.chapterBoardId = '0'
      }
      this.spinner.show();
      this.chapterUserImage = document.getElementById("base64textareaUser").textContent;

      const userData = {
        "filter": {
          "siteId": this.siteId,
          "bpgId": this.bpgId,

        },
        "id": this.loginData.userId,
        "userId": this.userId,
        "designation": this.designation,
        "emailId": this.emailId,
        "userPic": this.uploadFileNameUser,
        "chapterUserImage": this.chapterUserImage,
        "teamOrder": this.teamOrder,
        "pronoun": this.pronoun,
        "chapterBoardId": this.chapterBoardId,
        "chapterFlag": this.chapterFlag,
      }

      this.userService.addChapterBoardMember(userData).subscribe(data => {
        if (data.message !== undefined) {
          this.errorMessageChapterBoard = data.message;
          this.errorMessageActiveChapterBoard = true;
          this.chapterMemberSuccess = false;
          this.noUserChapterBoard = false;
          this.userFoundChapterBoard = false;
        } else if (data !== undefined) {
          this.errorMessageActiveChapterBoard = false;
          this.noUserChapterBoard = false;
          this.userFoundChapterBoard = false;
          this.chapterMemberSuccess = true;
          this.deleteMember = false;
          this.getChapterBoard();
          setTimeout(() => {
            this.resetBoard()
          }, 2500);


        } setTimeout(() => {
          window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 200);
        this.spinner.hide();
      })
    }
    if (!this.isChapterExist) {
      this.timeOutError = false;
      if (this.startDate === null || this.startDate === "") {
        this.startDate = new Date().toISOString();
      }
      this.chapterBannerImage = document.getElementById("base64textarea").textContent;
      if (this.chapterBannerImage.length === 0) {
        this.chapterBannerImage = null;
      }
      this.executiveSponsorImage = document.getElementById("base64textareaExecutiveSponser").textContent;
      if (this.executiveSponsorImage.length === 0) {
        this.executiveSponsorImage = null;
      }
      this.uploadPhotoChairImage = document.getElementById("base64textareaChair").textContent;
      if (this.uploadPhotoChairImage.length === 0) {
        this.uploadPhotoChairImage = null;
      }
      this.uploadPhotoViceChairImage = document.getElementById("base64textareaViceChair").textContent;
      if (this.uploadPhotoViceChairImage.length === 0) {
        this.uploadPhotoViceChairImage = null;
      }
      this.uploadPhotoFinanceChairImage = document.getElementById("base64textareaFinanceChair").textContent;
      if (this.uploadPhotoFinanceChairImage.length === 0) {
        this.uploadPhotoFinanceChairImage = null;
      }
      this.uploadPhotoCommunicationChairImage = document.getElementById("base64textareaCommunicationChair").textContent;
      if (this.uploadPhotoCommunicationChairImage.length === 0) {
        this.uploadPhotoCommunicationChairImage = null;
      }
      const data = {

        "chaptersDTO": {
          "chapterId": this.chapterId,
          "bpgId": this.bpgId,
          "siteId": this.siteId,
          "startDate": this.startDate,
          "endDate": this.endDate,
          "chapterBanner": this.bannerFileName,
          "chapterMission": this.chapterMission,
          "chapterVision": this.chapterVision,
          "chapterEmail": this.chapterEmail,
          "bpgDate": this.bpgDate,
          "isActive": this.setStatus,
          "modifiedBy": "1",
          "createdBy": "1"
        },
        "chaptersLeadershipRequestDTO": [
        ],
        "chapterBannerImage": this.chapterBannerImage,
        "editAndSave": this.editandSavebtn,
        "executiveSponsorImage": this.executiveSponsorImage,
        "UserId": this.loginData['userId'],
        "chaptersExecutiveSponsorDTO": {
          "chapterExecutiveSponsorId": 0,
          "chapterId": this.chapterId,
          "executiveSponsorName": this.sponserName,
          "startDate": this.startDate,
          "endDate": this.endDate,
          "userPic": this.sponserFileName,
          "executiveSponsorEmailId": this.sponsorEmailId,
          "isActive": this.setStatus,
          "modifiedBy": "1",
          "createdBy": "1",
          "executiveSponsorPronounce": this.sponserPronoun
        }
      }

      data.chaptersLeadershipRequestDTO.push(

        {
          "createdBy": "1",
          "modifiedBy": "1",
          "createdDateTime": this.startDate,
          "modifiedDateTime": this.startDate,
          "isActive": this.setStatus,
          "chapterLeadershipId": 0,
          "chapterId": data.chaptersDTO.chapterId,
          "startDate": this.startDate,
          "endDate": this.endDate,
          "userPic": this.chairFileName,
          "positionName": ConstantValues.leadershipPosition.chair,
          "userId": this.userId1,
          "chapterLeaderImage": this.uploadPhotoChairImage,
          "emailAddress": this.chairEmailId,
          "leadershipPronounce": this.chairPronoun

        },

        {
          "createdBy": "1",
          "modifiedBy": "1",
          "createdDateTime": this.startDate,
          "modifiedDateTime": this.startDate,
          "isActive": this.setStatus,
          "chapterLeadershipId": 0,
          "chapterId": data.chaptersDTO.chapterId,
          "startDate": this.startDate,
          "endDate": this.endDate,
          "userPic": this.viceChairFileName,
          "positionName": ConstantValues.leadershipPosition.viceChair,
          "userId": this.userId2,
          "chapterLeaderImage": this.uploadPhotoViceChairImage,
          "emailAddress": this.viceChairEmailId,
          "leadershipPronounce": this.viceChairPronoun

        },

        {
          "createdBy": "1",
          "modifiedBy": "1",
          "createdDateTime": this.startDate,
          "modifiedDateTime": this.startDate,
          "isActive": this.setStatus,
          "chapterLeadershipId": 0,
          "chapterId": data.chaptersDTO.chapterId,
          "startDate": this.startDate,
          "endDate": this.endDate,
          "userPic": this.financeChairFileName,
          "positionName": ConstantValues.leadershipPosition.financeChair,
          "userId": this.userId3,
          "chapterLeaderImage": this.uploadPhotoFinanceChairImage,
          "emailAddress": this.financeChairEmailId,
          "leadershipPronounce": this.financeChairPronoun
        },

        {
          "createdBy": "1",
          "modifiedBy": "1",
          "createdDateTime": this.startDate,
          "modifiedDateTime": this.startDate,
          "isActive": this.setStatus,
          "chapterLeadershipId": 0,
          "chapterId": data.chaptersDTO.chapterId,
          "startDate": this.startDate,
          "endDate": this.endDate,
          "userPic": this.communicationFileName,
          "positionName": ConstantValues.leadershipPosition.communicationChair,
          "userId": this.userId4,
          "chapterLeaderImage": this.uploadPhotoCommunicationChairImage,
          "emailAddress": this.commChairEmailId,
          "leadershipPronounce": this.communicationChairPronoun
        })
      this.spinner.show();
      this.userService.saveAllChapter(data).subscribe(data1 => {
        if (data1 != null && data1 !== undefined) {
          this.isExistChapter = true;
          this.chapterId = data1.body.chaptersDTO.chapterId

          if (this.saveAndUpdateBoard === true) {
            this.chapterFlag = "saveAndUpdateBoard"
          }
          else {
            this.chapterFlag = "saveBoard";
            this.chapterBoardId = '0'
          }
          this.spinner.show();
          this.chapterUserImage = document.getElementById("base64textareaUser").textContent;

          const userData = {
            "filter": {
              "siteId": this.siteId,
              "bpgId": this.bpgId,

            },
            "id": this.loginData.userId,
            "userId": this.userId,
            "designation": this.designation,
            "emailId": this.emailId,
            "userPic": this.uploadFileNameUser,
            "chapterUserImage": this.chapterUserImage,
            "teamOrder": this.teamOrder,
            "pronoun": this.pronoun,
            "chapterBoardId": this.chapterBoardId,
            "chapterFlag": this.chapterFlag,
          }

          this.userService.addChapterBoardMember(userData).subscribe(data => {
            this.spinner.hide();
            if (data.message !== undefined) {
              this.errorMessageChapterBoard = data.message;
              this.errorMessageActiveChapterBoard = true;
              this.chapterMemberSuccess = false;
              this.noUserChapterBoard = false;
              this.userFoundChapterBoard = false;
            } else if (data !== undefined) {
              this.errorMessageActiveChapterBoard = false;
              this.noUserChapterBoard = false;
              this.userFoundChapterBoard = false;
              this.chapterMemberSuccess = true;
              this.deleteMember = false;
              this.isChapterExist = true;
              this.getChapterBoard();
              setTimeout(() => {
                this.resetBoard()
              }, 2000);


            } setTimeout(() => {
              window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
            }, 200);
            this.spinner.hide();
          })
        }
      })
    }


  }


  /** to edit chapter member 
* @class chapterBoardComponent
* @method editBoard
*/
  editBoard(data, i) {
    if (this.designation != null || this.emailId != null) {
      this.firstEditChapterTeam = false;
    }
    if (this.firstEditChapterTeam === true) {
      this.firstEditChapterTeam = false;
      this.editBoardData(data);
    } else {
      document.getElementById('editRt' + i).setAttribute(this.dataToggleConstant, 'modal');
      document.getElementById('editRt' + i).setAttribute(this.dataTargetConstant, '#myModal');
      this.method = "editBoardData";
      this.param = data;
      this.msg1 = this.msg1Constant;
    }
  }

  editBoardData(data) {

    if (this.designation != null || this.emailId != null) {
      this.firstEditChapterTeam = false;
    }
    if (this.firstEditChapterTeam === true) {
      this.firstEditChapterTeam = false;
      
    } 

    this.butDisabledChapterBoard = false;
    this.noUserChapterBoard = false;
    this.userFoundChapterBoard = false;
    this.searchTerm = null
    this.memberPic = document.getElementById('filenameUserPic');
   
    this.uploadFileNameUser = data.userPic;
    this.chapterUserImage = '';
    this.userFirstName = data.userName;
    this.designation = data.designation;
    this.emailId = data.emailId;
    this.userPic = data.userPic;

    this.teamOrder = data.teamOrder;
    this.chapterBoardId = data.chapterBoardId;
    this.userId = data.userId;
    this.pronoun = data.pronoun;
    this.saveBoard = false;
    this.saveAndUpdateBoard = true;
    this.chapterMemberSuccess = false;
    setTimeout(() => {
      this.openAndCloseMatDialog('open');
    }, 500);
  }


  /** to reset chapter member list
* @class chapterBoardComponent
* @method resetBoard
*/
  resetBoard() {
    this.userList = null;
    this.designation = null
    this.userId = null
    this.userFirstName = null
    this.searchTerm = null
    this.emailId = null
    this.userPic = null
    this.teamOrder = null
    this.searchKeyChapterBoard = null;
    this.chapterMemberSuccess = false;
    this.chapterUserImage = null;
    this.chapterBoardId = '0';
    this.chapterBoardEmailValid = false;
    this.uploadFileExtensionUser = false
    this.errorMessageActiveChapterBoard = false;
    this.pronoun = '';
    this.uploadFileNameUser = this.uploadFileTypeConstant;
    document.getElementById("base64textareaUser").textContent = '';
    document.getElementById("filenameUserPic").textContent = this.uploadFileTypeConstant;
    this.saveBoard = true;
    this.saveAndUpdateBoard = false;
    this.butDisabledChapterBoard = true;
    this.chapterFlag = 'saveBoard'
  }


  /** to search chapter member
* @class chapterBoardComponent
* @method searchBoard
*/
  searchBoard() {
    this.clearAlertsChapterBoard();
    this.spinner.show();
    this.searchKeyChapterBoard = (this.searchKeyChapterBoard) ? this.searchKeyChapterBoard : '';
    this.LandingPaginationDTO.page = 0;
    this.LandingPaginationDTO.searchTerm = this.searchKeyChapterBoard;
    this.currentPageChapterBoard = 1;
    this.getChapterBoard();
    this.spinner.hide();
  }

  /** to get chapter member list
* @class chapterBoardComponent
* @method getChapterBoard
*/

  getChapterBoard() {
   
    this.spinner.show();

    const LandingPaginationDTO = {
      "filter": {
        "siteId": this.siteId,
        "bpgId": this.bpgId,
        "chapterFlag": 'chapterboard'

      },
      "moduleId": 0,
      "page": 0,
      "presentRole": "",
      "searchTerm": "",
      "size": 500,
      "sortDirection": "ASC",
      "sortProperty": "teamOrder",
      "uid": ""
    }
    this.chapterBoardList = [];
    this.userService.getChapterBoardMember(LandingPaginationDTO).subscribe(data => {
      if (data != null && data !== undefined){
        this.chapterBoardList = data.content;
      }
    })
    this.spinner.hide();

  }


  /** to Delete chapter member
* @class chapterBoardComponent
* @method deleteBoard
*/
  public deleteBoard(id, i) {
    document.getElementById('deleteBoard' + i).setAttribute(this.dataToggleConstant, 'modal');
    document.getElementById('deleteBoard' + i).setAttribute(this.dataTargetConstant, '#myModal');
    this.method = "deleteBoardConfirmation";
    this.param = id;
    this.msg1 = "  Are you sure you want to delete the member? ";
  }

  deleteBoardConfirmation(id) {

    this.userService.deleteChapterBoard(id).subscribe(_data => {
      this.deleteMember = true;
      this.getChapterBoard();
    })
  }

  logUserAction() {
    const data = {
      userId : this.userId,
      categoryDescription : "SelfServices - Chapters Screen"
    };
    this.bpgCommonService.logUserAction(data).subscribe(
      (_data) => {});
  }
}
